import { getStoredUser, StoredUser } from './subscriptionService';

export type GuardReason = 'unauthenticated';

export interface GuardSuccess {
    allowed: true;
    user: StoredUser;
    token: string;
}

export interface GuardFailure {
    allowed: false;
    reason: GuardReason;
    message: string;
    redirectTo: string;
}

export type GuardResult = GuardSuccess | GuardFailure;

export const clearAuthSession = (): void => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
};

export const ensureAuthenticated = (): GuardResult => {
    const token = localStorage.getItem('authToken');
    const user = getStoredUser();

    if (!token || !user) {
        return {
            allowed: false,
            reason: 'unauthenticated',
            message: 'Please log in to continue.',
            redirectTo: '/signin'
        };
    }

    return {
        allowed: true,
        token,
        user
    };
};
